<ngx-extended-pdf-viewer [src]="pdf"
                         [showToolbar]="true"
                         [showSidebarButton]="true"
                         [showFindButton]="true"
                         [showPagingButtons]="true"
                         [showDrawEditor]="false"
                         [showStampEditor]="false"
                         [showTextEditor]="false"
                         [showZoomButtons]="true"
                         [showPresentationModeButton]="true"
                         [showOpenFileButton]="false"
                         [showPrintButton]="showPrintButton"
                         [showSecondaryToolbarButton]="true"
                         [showRotateButton]="true"
                         [showRotateCwButton]="true"
                         [showRotateCcwButton]="true"
                         [showHandToolButton]="true"
                         [showScrollingButton]="true"
                         [showSpreadButton]="true"
                         [showHighlightEditor]="false"
                         [showDownloadButton]="enabledDocumentDownloads"
                         [showPropertiesButton]="false">
</ngx-extended-pdf-viewer>
